module.exports = __webpack_public_path__ + "img/result-restore-btn.41b3f28f.png";